<template>
  <div class="priceList" v-if="priceData">
    <table>
      <tr class="under_separator">
        <td>商品・配送費</td>
        <td></td>
        <td class="price">{{formatPrice(profitPrice(priceData.subTotalPrice))}}</td>
      </tr>
      <tr>
        <td>{{priceData.itemName}}</td>
        <td>{{formatPrice(profitPrice(priceData.itemPrice))}} × {{dcProductCount}}</td>
        <td>{{formatPrice(profitPrice(priceData.itemPrice * dcProductCount))}}</td>
      </tr>
      <tr v-if="isCalcDelivery">
        <td>配送料</td>
        <td>{{formatPrice(profitPrice(priceData.delivaryPrice * dcProductCount))}} × 1</td>
        <td class="price">{{formatPrice(profitPrice(priceData.delivaryPrice * dcProductCount))}}</td>
      </tr>
    </table>
    <table class="tbl_space">
      <tr class="under_separator" v-if="priceData.optionSubTotalPrice">
        <td>組立設置他サービス小計</td>
        <td></td>
        <td class="price">{{formatPrice(profitPrice(priceData.optionSubTotalPrice))}}</td>
      </tr>
      <tr v-if="priceData.constructPrice">
        <td>組立技術料</td>
        <td>{{formatPrice(profitPrice(priceData.constructPrice * dcProductCount))}} × 1</td>
        <td class="price">{{formatPrice(profitPrice(priceData.constructPrice * dcProductCount))}}</td>
      </tr>
      <tr v-if="priceData.carryInPrice">
        <td>受け取り搬入サービス費</td>
        <td>{{formatPrice(profitPrice(priceData.carryInPrice * dcProductCount))}} × 1</td>
        <td class="price">{{formatPrice(profitPrice(priceData.carryInPrice * dcProductCount))}}</td>
      </tr>
      <tr v-if="priceData.executionVarExpensesPrice">
        <td>諸経費</td>
        <td>{{formatPrice(profitPrice(priceData.executionVarExpensesPrice))}} × 1</td>
        <td class="price">{{formatPrice(profitPrice(priceData.executionVarExpensesPrice))}}</td>
      </tr>
    </table>
    <div class="totalPrice upper_separator">
      <div>合計金額（税抜）</div>
      <div>{{formatPrice(profitPrice(priceData.totalPrice))}}</div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    priceData: {
      type: Object
    },
    isCalcDelivery: {
      type: Boolean,
      default: false
    },
    dcProductCount: {
      type: Number,
      default: 0
    },
    isProfitFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    itemList: function () {
      if (!this.priceData.itemModelList) return
      return this.priceData.itemModelList
        .filter(e => e.accessoryType === 'PLAN')
    },
    optionFillerList: function () {
      if (!this.priceData.itemModelList) return
      return this.priceData.itemModelList
        .filter(e => e.accessoryType === 'OPTION')
        .filter(e => e.objectDtlType === 'UNIT_FILLER')
    },
    optionShelfList: function () {
      if (!this.priceData.itemModelList) return
      return this.priceData.itemModelList
        .filter(e => e.accessoryType === 'OPTION')
        .filter(e => e.objectDtlType === 'UNIT_MOBILE_SHELF')
    }
  },
  methods: {
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    itemType: function (type) {
      if (type === 'PART_DOOR_BOARD') {
        return '扉:'
      } else if (type === 'UNIT_SKELTON') {
        return '箱:'
      } else if (type === 'UNIT_MOBILE_SHELF') {
        return '棚板：'
      } else if (type === 'UNIT_FILLER') {
        return 'フィラー：'
      }
      return ''
    },
    sizeName: function (w, h, d) {
      if (!w || !h || !d) return ''
      return w + '×' + h + '×' + d + '(mm)'
    },
    profitPrice: function (price) {
      if (!price || !this.priceData) return
      return (this.isProfitFlag ? Math.ceil(price / this.priceData.profitProb) : price)
    }
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/payment/PriceList.vue